import { render, staticRenderFns } from "./myhead.vue?vue&type=template&id=6f8fc0a5&scoped=true"
import script from "./myhead.vue?vue&type=script&lang=js"
export * from "./myhead.vue?vue&type=script&lang=js"
import style0 from "./myhead.vue?vue&type=style&index=0&id=6f8fc0a5&prod&scoped=true&lang=css"
import style1 from "./myhead.vue?vue&type=style&index=1&id=6f8fc0a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8fc0a5",
  null
  
)

export default component.exports